import { type ReactElement } from "react";
import { useHasFeatureFlagActivated } from "src/hooks";

import type { FeatureFlags } from "@emeria/feature-flags";

interface Props {
  feature: FeatureFlags;
  children: ReactElement;
}

export const FeatureFlag = ({ feature, children }: Props) => {
  if (!useHasFeatureFlagActivated(feature)) {
    return null;
  }

  return children;
};
